import { ReactElement } from 'react';
import { ContentAlert } from '@client/common/components/Modal/ModalContents';
import { NavigationPrompt } from '@client/common/components/NavigationPrompt';
import { useTranslate } from '@client/i18n/hooks';
import { ALERT_STYLE_TYPE } from 'b2b-components/core/components/Alert';
import { ModalButtons } from 'b2b-components/core/components/Modal';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from 'b2b-components/theme/components/Button';
import { Modal, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { Props } from './ModifyNewsletters.types';

export const ModifyNewsletters = ({
  isModalVisible,
  isSubmitting,
  onButtonClick,
  onModalClose,
  updateNewslettersData,
  wereCheckboxesChanged,
}: Props): ReactElement => {
  const t = useTranslate();
  const { isLoaded, hasFailed } = updateNewslettersData;

  return (
    <>
      <Button
        isDisabled={isSubmitting}
        onClick={onButtonClick}
        size={BUTTON_SIZE.small}
        type={BUTTON_TYPE.submit}
      >
        {isSubmitting ? t('Submitting...') : t('Save newsletter settings')}
      </Button>

      <Modal
        title={hasFailed ? t('Error') : t('Changes saved')}
        content={() => (
          <>
            {isLoaded && (
              <ContentAlert
                text={t('Your newsletter settings were successfully updated.')}
                alertType={ALERT_STYLE_TYPE.success}
              />
            )}
            {hasFailed && (
              <ContentAlert
                text={t('There was an error during your request. Changes were not saved. Please try again.')}
                alertType={ALERT_STYLE_TYPE.error}
              />
            )}
            <ModalButtons
              secondary={{
                onClick: onModalClose,
                label: t('Close'),
              }}
            />
          </>
        )}
        isOpen={isModalVisible}
        onCloseModal={onModalClose}
        type={MODAL_TYPE.small}
      />

      <NavigationPrompt shouldConfirmNavigation={wereCheckboxesChanged} />
    </>
  );
};
